<template>
  <div class="log-query">
     <NginxMonitor ref="NginxMonitor"></NginxMonitor>
     <Modal title="显示列" v-model="tableColModal">
      <Checkbox-group v-model="col">
        <Checkbox :label="item.key" v-for="item in tableColumnList" :key="item.key" v-if="item.key">{{ item.title }}</Checkbox>
      </Checkbox-group>
      <div slot="footer">
        <Button type="primary" :loading="saveShowColConfiging" style="margin-right: 8px" icon="md-checkmark" @click="saveShowColConfig">确认</Button>
        <Button @click="tableColModal = false">取消</Button>
      </div>
    </Modal>
    <Card style="margin-bottom:10px;">
     <Form ref="searchForm" inline :model="searchForm" :rules="ruleValidSearch">
      <Row>
          <!-- <FormItem label="索引名称" prop="index_name">
          <i-select v-model="searchForm.indexName"  style="width: 90%;" @on-change="onSelectIndex">
            <i-option v-for="item in indexList" :value="item" :key="item" :label="item"></i-option>
            </i-select>
          </FormItem> -->
          <FormItem label="时间" prop="logDate" :label-width="60" class="mob-w-100">
            <DatePicker type="daterange" :disabled="dateDisabled" placeholder="Select date and time"  format="yyyy-MM-dd" v-model="searchForm.logDate"></DatePicker>
          </FormItem>
           <!-- <form-item>
              <radio-group v-model="searchForm.selectTime" type="button"  @on-change="lastTimeChange">
                <radio label="">无</radio>
                <radio label="1">1分钟</radio>
                <radio label="5">5分钟</radio>
                <radio label="10">10分钟</radio>
                <radio label="20">20分钟</radio>
                <radio label="30">30分钟</radio>
                <radio label="60">60分钟</radio>
              </radio-group>
          </form-item>
          <Tooltip content="自动刷新" placement="bottom">
            <i-switch v-model="monitorModal" style="margin-top: 5px" size="large" @on-change="controlMonitorTimer">
              <span slot="open">自动</span>
              <span slot="close">关闭</span>
            </i-switch>
          </Tooltip> -->
      <!--</i-col>-->
      <!--<i-col span="6">-->
            <!-- <Button type="primary" @click="getLogsDetail">搜索</Button>
            <Button @click="searchReset" style="margin-left: 10px;">重置</Button> -->
        <!-- <Button style="float: right;" @click="addIndex" type="primary" :style="{marginBottom: '10px'}">添加索引</Button> -->
      <!--</i-col>-->
      <!--</Row>
      <Row>-->
        <!--<i-col span="24">-->
          <!-- <FormItem label="显示条数" prop="size" :label-width="100" >
            <InputNumber :max="10000" :min="1" v-model="searchForm.size" class="mob-w-100"></InputNumber>
          </FormItem>
            <FormItem label="路径"  prop="module" :label-width="60"  >
               <Input v-model="searchForm.module" placeholder="日志文件绝对路径(可模糊匹配)" style="min-width: 300px" class="mob-w-100"/>
          </FormItem> -->
          <!-- <form-item label="项目" prop="category" :label-width="60">
            <i-select v-model="searchForm.category"  style="min-width: 80px">
                <Option value="baiyiqa">佰易</Option>
                <Option value="tomcat">运维平台</Option>
                <Option value="nginx">nginx</Option>
            </i-select>
        </form-item> -->
         <FormItem label="主机" prop="host" :label-width="60"  >
          <!-- <i-select v-model="searchForm.host" style="min-width: 450px" filterable clearable multiple>
            <i-option v-for="item in hostList" :value="item" :key="item" :label="item"></i-option>
          </i-select> -->
            <ServerTree ref="serverTree" :hosts="logHosts"/>
         </FormItem>
            <!-- <FormItem label="全文搜索" prop="key" :label-width="110">
              <Input v-model="searchForm.key" search enter-button="开始分析" @on-search="analyzeLog('searchForm')"  placeholder="输入过滤关键字" style="min-width: 530px" class="mob-w-100"/>
          </FormItem> -->
            <Button style="margin-left:5px;" type="info" @click="analyzeLog('searchForm')">开始分析</Button>
         </Row>
         <Row>
        <Col :lg="24" style="margin-top: 8px">
        <Card shadow class="no-padding-card-body">
          <p slot="title">
            <span>日志路径统计报表</span>
          </p>
          <div>
            <Alert type="error" v-if="contentCost.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Row :gutter="16" v-else>
              <Col :lg="24" style="margin-top: 8px">
                <div id="bre_mon_product_id" style="width: 100%; height: 550px;"></div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
       <!-- <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 500px" class="no-padding-card-body">
          <p slot="title">
            <span>日志内容重复统计报表</span>
          </p>
          <div>
            <Alert type="error" v-if="contentCost.error" show-icon style="margin: 16px;">获取数据失败</Alert>
            <Row :gutter="16" v-else>
              <Col :lg="24" style="margin-top: 8px">
                <div id="bre_mon_content_id" style="width: 100%; height: 450px;"></div>
              </Col>
            </Row>
          </div>
        </Card>
      </Col> -->
      </Row>
    </Form>
     <Row>
        <!-- <Table
          ref="table"
          size="small"
          :columns="table.columns"
          :data="table.data"
          :loading="table_loading"
          @on-sort-change="changeSort"
        ></Table>
           <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: left;">
                当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
              </div>
              <div style="float: right;">
                <page
                  :total="table.count"
                  :current="table.page"
                  :page-size="table.size"
                  @on-change="getLogsDetail"></page>
              </div>
           </div> -->
      </Row>
      <Drawer
        title="添加索引"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem label="索引名称" prop="indexName">
            <i-input v-model="formItem.indexName" placeholder="请输入索引名称" style="width: 200px;"></i-input>
          </FormItem>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
    <!-- <Card :bordered="false">
      <Row style="margin: 1px;">
        <div style="float: center;background:#eee;padding: 2px;min-height:600px">
          <span v-html="logContent"/>
       </div>
     </Row>
    </Card> -->
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { reAnalyzeLogs, createIndex, deleteIndex, analyzeList, queryHosts, queryHostPathCount } from '@/api/log'
import { getOpsCenterAllServer } from '@/api/opscenter'
import { getModuleAllListLog } from '@/api/workflow/project'
import moment from 'moment'
import NginxMonitor from './NginxMonitor'
import ServerTree from '@/view/components/server/server-tree'
import echarts from '@/view/monitor/components/echarts-use.js'

export default {
  name: 'LogAnalyze',
  components: {
    NginxMonitor,
    ServerTree
  },
  data () {
    let that = this
    return {
      productCost: {
        searchForm: {
          platformAndUsername: '',
          support: null,
          username: null
        },
        loading: false,
        error: false,
        barOption: {
          legend: {},
          tooltip: {
            trigger: 'axis',
            showContent: false
          },
          dataset: {
            source: [
            ]
          },
          xAxis: {type: 'category'},
          yAxis: {gridIndex: 0},
          grid: {top: '35%'},
          series: [
          ]
        }
      },
      contentCost: {
        searchForm: {
          platformAndUsername: '',
          support: null,
          username: null
        },
        loading: false,
        error: false,
        barOption: {
          backgroundColor: '#fff',
          grid: {
            left: 100,
            top: '20%',
            bottom: 60,
            right: 0
          },
          legend: {
            data: [],
            align: 'left',
            right: 0
            // textStyle: {
            //   color: '#434e79',
            //   fontSize: 14,
            //   fontWeight: 400
            // },
            // itemWidth: 14,
            // itemHeight: 10,
            // itemGap: 35
          },
          tooltip: {
            trigger: 'axis',
            padding: [8, 10],
            backgroundColor: 'rgba(0,0,0,0.5)',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff'
              }
            }
          },
          xAxis: [{
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#434e79',
                fontSize: 16,
                fontWeight: 400
              }
            }
          }],
          yAxis: [{
            min: 0,
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            }
          }],
          series: []
        },
        pieOption: {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: function (data, index) {
              let res = `<div class="circle_tooltip" style="background-color: ${data.color}"></div>` +
                `<span>${data.name}</span> : <span>${data.value}</span>(${data.percent}%)<br/>`

              return res
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: [],
            show: false
          },
          series: [
            {
              name: '日志路径',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              data: [],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  formatter: function (data, index) {
                    return `${data.name}：${data.value}  {per|${data.percent}%}\n  `
                  },
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 15,
                      align: 'center'
                    },
                    b: {
                      fontSize: 12
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              }
            }
          ]
        }
      },
      logHosts: [],
      status: null,
      ordering: null,
      dateDisabled: false,
      col: [],
      saveShowColConfiging: false,
      tableColModal: false,
      timer: null,
      monitorModal: false,
      moduleList: [],
      changeLoadingShow: false,
      change: false,
      logContent: '',
      indexList: [],
      hostList: [],
      searchForm: {
        host: [],
        module: 'nginx',
        logDate: null,
        size: 100,
        key: null,
        category: this.$store.state.user.defaultTenant,
        selectTime: ''
      },
      formItem: {
        indexName: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidSearch: {
        // host: [{ required: true, type: 'string', message: '主机名不能为空 !', trigger: 'change' }],
        module: [{ required: true, type: 'string', message: '日志路径不能为空 !', trigger: 'blur' }],
        logDate: [{ required: true, type: 'array', message: '请选择查询时间', trigger: 'change' }],
        size: [{ required: true, type: 'number', message: '显示条数不能为空 !', trigger: 'blur' }]
      },
      ruleValidate: {
        // host: [{ required: true, message: '主机名不能为空 !', trigger: 'change' }],
        // logDate: [{ required: true, type: 'date', message: '请选择查询时间', trigger: 'change' }]
      },
      tableColumnList: {
      },
      table: {
        data: [],
        columns: [
          {
            minWidth: 20,
            title: '日志类型',
            align: 'left',
            key: 'log_type'
          },
          {
            minWidth: 100,
            title: '日志路径',
            align: 'left',
            key: 'log_path'
          },
          {
            minWidth: 50,
            title: '日志开始时间',
            align: 'left',
            key: 'time_start',
            render: (h, params) => {
              if (params.row['time_start']) {
                return h('div', moment(params.row['time_start']).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            minWidth: 50,
            title: '日志结束时间',
            align: 'left',
            key: 'time_finish',
            render: (h, params) => {
              if (params.row['time_finish']) {
                return h('div', moment(params.row['time_finish']).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            minWidth: 200,
            sortable: 'custom',
            render: (h, params) => {
              const row = params.row
              const color = row.status === '0' ? 'info' : row.status === '1' ? 'warning' : row.status === '2' ? 'success' : 'error'
              const text = row.status === '0' ? '未生成' : row.status === '1' ? '生成中' : row.status === '2' ? '已生成' : '生成失败'
              // 未安装， 正常， 异常
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, text)
            },
            filters: [
              {
                label: '未生成',
                value: '0'
              },
              {
                label: '生成中',
                value: '1'
              },
              {
                label: '已生成',
                value: '2'
              },
              {
                label: '生成失败',
                value: '3'
              }
            ],
            filterMultiple: false,
            filterRemote (value, row) {
              if (value.length > 0) {
                that.status = value[0]
              } else {
                that.status = null
              }
              that.getLogsDetail()
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 360,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (params.row.html_path) {
                        this.$refs.NginxMonitor.show(params.row.html_path)
                      } else {
                        this.$Modal.warning({
                          title: '分析结果生成中,请稍后刷新查看'
                        })
                      }
                    }
                  }
                }, '查看分析结果'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    display: params.row.status === '2' ? 'none' : 'inline-block',
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      if (params.row.id) {
                        this.reAnalyzeLogs(params.row.id)
                      }
                    }
                  }
                }, '重新生成')
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      tableData: [],
      table_loading: false
    }
  },
  watch: {
    // '$store.state.user.defaultTenant' () {
    //   this.getModuleAllListLog()
    //   this.searchForm.category = this.$store.state.user.defaultTenant
    // }
  },
  beforeDestroy () {
    // clearInterval(this.timer)
    // this.timer = null
  },
  created () {
    // clearInterval(this.timer)
    // this.timer = null
    // this.getShowCol()
  },
  methods: {
    // queryHostPathCount () {
    //   queryHostPathCount().then(res => {
    //     this.logHosts = res.data.data
    //   }).catch(res => {
    //     if (res.request) {
    //       this.$Notice.error({
    //         title: '获取日志列表失败！请求状态码:' + res.request.status,
    //         desc: res.request.responseText
    //       })
    //     }
    //   })
    // },
    getLogHosts () {
      this.logHosts = []
      queryHosts().then(res => {
        this.logHosts = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeSort (column) {
      if (column.key === 'status') {
        if (column.order === 'asc') {
          this.ordering = 'status'
        } else {
          this.ordering = '-status'
        }
      }
      this.getLogsDetail()
    },
    lastTimeChange () {
      if (this.searchForm.selectTime) {
        this.dateDisabled = true
        this.monitorModal = true
      } else {
        this.monitorModal = false
        this.dateDisabled = false
      }
      this.controlMonitorTimer()
    },
    getShowCol () {
      this.col = ['message', 'timestamp', 'host', 'path']
      this.getTableColumns()
    },
    saveShowColConfig () {
      this.saveShowColConfiging = true
      this.getTableColumns()
      this.saveShowColConfiging = false
      this.tableColModal = false
    },
    getTableColumns () {
      let data = []
      this.col.forEach(col => data.push(this.tableColumnList[col]))
      data.sort(function (a, b) {
        return b.minWidth - a.minWidth
      })
      this.columns = data
    },
    showColConfig () {
      this.tableColModal = true
    },
    // 自动刷新
    setTimer () {
      // if (this.timer == null) {
      //   this.timer = setInterval(() => {
      //     this.getLogsDetail
      //   }, 5000)
      // }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      if (this.monitorModal) {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getModuleAllListLog () {
      this.searchForm['module'] = ''
      getModuleAllListLog({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    deleteIndex () {
      deleteIndex().then(res => {
      })
    },
    handleDateChange (value) {
    },
    // addIndex () {
    //   this.formItem.userId = null
    //   this.change = true
    // },
    getLogsDetail (value = 1) {
      this.table.page = value
      this.table_loading = true
      let params = {
        size: this.table.size,
        page: this.table.page,
        ordering: this.ordering,
        status: this.status
      }
      analyzeList(params).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.table_loading = false
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    analyzeLog (name) {
      this.table_loading = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs.serverTree.server_obj && this.$refs.serverTree.server_obj.length === 1) {
            // let hostStr = this.searchForm['host']
            let beginTime = dayjs(this.searchForm.logDate[0]).format('YYYY-MM-DD HH:mm:ss')
            let endTime = dayjs(this.searchForm.logDate[1]).format('YYYY-MM-DD HH:mm:ss')
            let params = {
              host: this.$refs.serverTree.server_obj ? this.$refs.serverTree.server_obj.map(j => j.label).join(',') : '',
              beginTime: beginTime,
              endTime: endTime
            }
            this.productCost.barOption.dataset.source = []
            this.productCost.barOption.series = []
            queryHostPathCount(params).then(res => {
              this.productCost.barOption.dataset.source.push(['product'].concat(res.data.date_list))
              console.log(this.productCost.barOption.dataset.source)
              let series = []
              for (let i in res.data.result) {
                series.push({
                  type: 'line',
                  smooth: false,
                  seriesLayoutBy: 'row'
                })
                this.productCost.barOption.dataset.source.push([i].concat(res.data.result[i]))
              }
              // series.push({
              //   id: 'pie',
              //   type: 'pie',
              //   radius: '30%',
              //   center: ['50%', '25%'],
              //   label: {
              //     formatter: '{b}: {@' + res.data.date_list[0] + '} ({d}%)'
              //   },
              //   encode: {
              //     itemName: 'product',
              //     value: res.data.date_list[0],
              //     tooltip: res.data.date_list[0]
              //   }
              // })
              this.productCost.barOption.series = series
              console.log(this.productCost.barOption.series)
              let chart = echarts.init(document.getElementById('bre_mon_product_id'), 'roma')
              // chart.on('updateAxisPointer', function (event) {
              //   var xAxisInfo = event.axesInfo[0]
              //   if (xAxisInfo) {
              //     var dimension = xAxisInfo.value + 1
              //     chart.setOption({
              //       series: {
              //         id: 'pie',
              //         label: {
              //           formatter: '{b}: {@[' + dimension + ']} ({d}%)'
              //         },
              //         encode: {
              //           value: dimension,
              //           tooltip: dimension
              //         }
              //       }
              //     })
              //   }
              // })
              console.log(this.productCost.barOption)
              chart.setOption(this.productCost.barOption, true)
            }).catch(res => {
              console.error(res)
            })
          } else {
            this.$Notice.error({
              title: '请选择一台主机进行分析'
            })
          }
        }
      })
    },
    reAnalyzeLogs (id) {
      let params = {
        id: id
      }
      reAnalyzeLogs(params).then(res => {
        this.getLogsDetail()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.index_name = ''
    },
    searchReset () {
      // this.searchForm.name = null
    },
    // getAllIndex () {
    //   getAllIndex().then(res => {
    //     this.indexList = res.data
    //   })
    // },
    onSelectIndex (value) {
    },
    onSelectCategory (value) {
    },
    initData () {
      this.searchForm.logDate = [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date()]
      this.getAssetOptions()
      this.getLogHosts()
      // this.queryHostPathCount()
    },
    getAssetOptions () {
      getOpsCenterAllServer().then(res => {
        this.hostList = res.data.map(item => item.hostname)
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          createIndex(params).then(res => {
            if (res.data.code === 200) {
              this.$Message.success('添加成功')
            }
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.initData()
    // this.getModuleAllListLog()
    this.getLogsDetail()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
<style lang="less">
.mob-d-t{
  .ivu-form-item-content{
    display: table;
    margin-left: 0!important;
    float: right;
  }
}
.log-query{
  .vue-treeselect__control{
    width:initial;
    min-width: 330px;
  }
  .vue-treeselect__multi-value-item-container {
      padding-top: 1px;
      height: 30px;
  }
  .vue-treeselect__multi-value-item{
    height: 96%;
  }
  .vue-treeselect__multi-value-item{
    line-height: 1;
  }
  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 0px;
  }
  .vue-treeselect__control{
    height: 32px;
  }
  .ivu-form-item-content{
    line-height: 30px;
  }
  .vue-treeselect__x-container{
    position: relative;
    right: 8px;
  }
}
</style>
